
export function padStart(value: string): string
{
  return ('0000000000' + value).slice(-10);
}
